module.exports = __webpack_public_path__ + "static/media/main-stage-2.a9eed3f6.png";